import { useEffect } from "react";

// Counted rather than flagged: two cards can want the page still at the same time, and the first one to
// close must not hand the scroll back while the other is still open.
let activeLocks = 0;
let overflowBeforeLocking = "";

/** Keeps the page behind a fixed overlay from scrolling under the wheel while active. */
export function useBodyScrollLock(active: boolean) {
    useEffect(() => {
        if (!active) {
            return;
        }

        if (activeLocks === 0) {
            overflowBeforeLocking = document.body.style.overflow;
            document.body.style.overflow = "hidden";
        }
        activeLocks++;

        return () => {
            activeLocks--;
            if (activeLocks === 0) {
                document.body.style.overflow = overflowBeforeLocking;
            }
        };
    }, [active]);
}
